import dynamic from "next/dynamic";

export const DynamicContent027 = dynamic(() => import("./Content027"), {
  suspense: true,
});
